import React from "react";
import AnyChart from 'anychart-react'
import anychart from "anychart";
const { Component } = React;

export default class EducationChart extends Component {

  constructor(props) {
    super(props);
    this.containerId = props.containerId;
    this.chart = anychart.pie();

    this.chart.title()
      .enabled(true)
      .text('Distribución por nivel educativo')
      .fontSize(14)

    this.chart.interactivity('single')
      .legend(false)
      .radius('48%')
      .innerRadius('57%');
  }

  generateChart(data) {

    var educationLevelCaption = data.captions["education_level"]
    var educationLabels = Object.keys(educationLevelCaption.labels);
    
    var prevData = {
      0: Array(educationLabels.length).fill(0),
      1: Array(educationLabels.length).fill(0)
    };

    var genderCount = [0, 0]
    Object.keys(data.counts).forEach((zoneId) => {
      data.counts[zoneId].segments.forEach((segment) => {
        prevData[segment.descriptors.gender][segment.descriptors.education_level] += segment.value;
        genderCount[segment.descriptors.gender] += segment.value;
      });
    });

    var chartData = [] 

    var colors = ['blue','hotpink']
    var palettes = [
      anychart.palettes.distinctColors(anychart.color.singleHueProgression(colors[0],educationLabels.length)),
      anychart.palettes.distinctColors(anychart.color.singleHueProgression(colors[1],educationLabels.length))
    ]

    Object.keys(prevData).forEach((gender) => {
      for (var educationLevel=0;educationLevel<educationLabels.length; educationLevel++) {
        chartData.push({
          "gender": gender,
          "education_level": educationLevel,
          "value": prevData[gender][educationLevel],
          "name": data.captions["gender"].labels[gender] + " - " + data.captions["education_level"].labels[educationLevel],
          "fill": palettes[gender].itemAt(educationLevel),
          "stroke": palettes[gender].itemAt(educationLevel)
        })
      }
    });


    this.chart.container(this.containerId);

    this.chart.data(chartData);

    function createChartLabel(chart, index, anchor, groupName) {
      var label = chart.label(index);
      label
        .position('center')
        .anchor(anchor)
        .offsetY(-10)
        .offsetX(5)
        .hAlign('center')
        .useHtml(true)
        .text(
          '<span style="font-size: 14px; font-weight: bold; color: '+ colors[index] + ' ">' +
          genderCount[index] +
          '</span><br><span style="font-size: 9px; font-weight: bold; color: '+ colors[index] + '">' +
          groupName.toUpperCase() +
          '</span>'
        );

      label.listen('mouseOver', function () {
        document.body.style.cursor = 'pointer';
        var groupIndexes = Array.from({length: educationLabels.length}, (_, i) => i + (index*educationLabels.length))

        chart.unhover();
        chart.hover(groupIndexes);
      });

      label.listen('mouseOut', function () {
        document.body.style.cursor = '';
        chart.unhover();
      });
    }

    createChartLabel(this.chart, 0, 'right-top', 'Hombres');
    createChartLabel(this.chart, 1, 'left-top', 'Mujeres');

    this.chart.draw();

    return this.chart;
  }

  render() { 
    return (
      <AnyChart 
        id={this.containerId}
        intance={ this.props.data != null ? this.generateChart(this.props.data) : null}>
      </AnyChart>
    )
  }

}
